import { render, staticRenderFns } from "./wbSettingDialog.vue?vue&type=template&id=5f94843b&scoped=true&"
import script from "./wbSettingDialog.vue?vue&type=script&lang=js&"
export * from "./wbSettingDialog.vue?vue&type=script&lang=js&"
import style0 from "./wbSettingDialog.vue?vue&type=style&index=0&id=5f94843b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f94843b",
  null
  
)

export default component.exports